import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchOnixCodetableItems } from "../api/onixService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
export var useOnixCodetableItemsData = function (selectedOnix, filters, pageSize) {
    var _a, _b;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    var ky = useOkapiKy();
    var hasAnyFilter = Boolean(selectedOnix || filters.value || filters.description);
    // The page belongs to the search it was paged in: another search starts on
    // the first page in the same render. (A reset in an effect first sent the new
    // search with the old offset, then again from the first page.)
    var searchKey = JSON.stringify([
        selectedOnix,
        filters.value,
        filters.description,
    ]);
    // The remembered page is dropped as soon as the search changes (state
    // adjusted during render), so returning to an earlier search starts on its
    // first page too.
    var _c = useState({ searchKey: searchKey, offset: 0 }), paging = _c[0], setPaging = _c[1];
    if (paging.searchKey !== searchKey) {
        setPaging({ searchKey: searchKey, offset: 0 });
    }
    var pageOffset = paging.searchKey === searchKey ? paging.offset : 0;
    var _d = useQuery(["onix-codetable-items", selectedOnix, filters, pageOffset, pageSize], function () {
        return fetchOnixCodetableItems(ky, {
            onixCodetableId: selectedOnix || undefined,
            value: filters.value,
            description: filters.description,
            offset: pageOffset,
            limit: pageSize,
        });
    }, { keepPreviousData: true, enabled: hasAnyFilter }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError, isFetched = _d.isFetched;
    var fetchMoreData = function (offset) {
        setPaging({ searchKey: searchKey, offset: offset });
    };
    var resetPageOffset = function () { return setPaging({ searchKey: searchKey, offset: 0 }); };
    return {
        items: (_a = data === null || data === void 0 ? void 0 : data.onixCodetableItems) !== null && _a !== void 0 ? _a : [],
        totalRecords: (_b = data === null || data === void 0 ? void 0 : data.totalRecords) !== null && _b !== void 0 ? _b : 0,
        isLoading: isLoading,
        isError: isError,
        isFetched: isFetched,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
